import { useForm } from "@ispb/react-form"
import { Alert, Form } from "react-bootstrap"
import IconText from "ui/components/IconText"
import { bsStringProps, formValidateWithMop } from "ui/form"
import FormOffset from "ui/form/FormOffset"
import FormRow from "ui/form/FormRow"
import FormSubmit from "ui/form/FormSubmit"
import FormUniversalError from "ui/form/FormUniversalError"
import { SAVE_ICON, USER_ICON } from "ui/icons"
import { Either } from "../namespaces/Either.js"
import { Mop } from "../namespaces/Mop.js"
import { AnonymousName } from "./index.js"

interface CollectNameInput {

    readonly name?: string | undefined
    readonly companyName?: string | undefined

}

export interface CollectNameProps {

    readonly setName: (name: AnonymousName) => void

}

function generateSchema() {
    return Mop.object({
        name: Mop.nonBlankString(),
        companyName: Mop.nonBlankString()
    })
}

export default function CollectName(props: CollectNameProps) {
    const form = useForm<CollectNameInput>({
        initial: {
            value: {},
        },
        autoUpdate: true,
        validate: formValidateWithMop(generateSchema),
        submit: value => {
            const result = Mop.exec(value, generateSchema())
            if (Either.isLeft(result)) {
                return result.left
            }
            props.setName(result.right)
        }
    })
    return (
        <div {...form.handlers}>
            <Alert variant="warning"><IconText {...USER_ICON}>Please enter your name to execute this procedure.</IconText></Alert>
            <FormUniversalError form={form} />
            <FormRow label="Name" field={form.prop("name")}>
                <Form.Control type="text" {...bsStringProps(form.prop("name"))} />
            </FormRow>
            <FormRow label="Company Name" field={form.prop("companyName")}>
                <Form.Control type="text" {...bsStringProps(form.prop("companyName"))} />
            </FormRow>
            <FormOffset>
                <div className="d-flex">
                    <FormSubmit label="Save" icon={SAVE_ICON} form={form} />
                </div>
            </FormOffset>
        </div>
    )
}
